import { DataList } from 'components/list/data.list'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useAppSelector } from 'store'
import { listUploads } from 'store/upload/selector'
import { MultipleUploadIndicator } from './multiple.upload.indicator'
import { UploadIndicator } from './upload.indicator'

const MAX_UPLOAD_DISPLAY_COUNT = 2

export const UploadIndicators: React.FC = () => {
  const { t } = useTranslation()

  const upload = useAppSelector(state => listUploads(state))

  useEffect(() => {
    if (!upload.isUploading) {
      window.onbeforeunload = null

      return
    }

    window.onbeforeunload = function (e) {
      const message = t('upload-in-progress', 'Abort upload?')

      e = e || window.event
      // For IE and Firefox
      if (e) {
        e.returnValue = message
      }

      // For Safari
      return message
    }
  }, [upload.isUploading])


  if (!upload.hasUploads) {
    return null
  }

  return (
    <div
      style={{
        background: '#FFF',
        borderRadius: 8,
        bottom: 100,
        position: 'fixed',
        right: 16,
        zIndex: 1000,
      }}
    >
      {

        (
          <DataList
            style={{
              maxHeight: '60vh',
              overflowY: 'auto',
            }}
            bordered
            dataSource={upload.uploads}
            renderItem={(id) => <UploadIndicator id={id} key={id} />}
          >
            {upload.uploads.length > MAX_UPLOAD_DISPLAY_COUNT && <MultipleUploadIndicator />}
          </DataList>
        )
      }
    </div>
  )
}
